import { globalStyles } from "consts/spaces";
import styled from "styled-components";

export const Slider = styled.div`
  .slider-services {
    position: relative;
    z-index: 9;

    .arrows {
      position: absolute;
      height: 48px;
      left: calc(calc(100dvw - 1590px) / 2);
      top: -72px;
      z-index: 3;
      display: flex;
      align-items: center;
      justify-content: end;
      gap: 8px;

      .arrow {
        height: 48px;
        width: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background: transparent;
        outline: none;
        border: none;
        border-radius: 4px;

        &.arrow-right,
        &.project-arrow-right,
        &.offers-arrow-right,
        &.vlog-arrow-right {
          transform: rotate(180deg);
        }

        &.swiper-button-disabled {
          svg path {
            fill: rgba(9, 30, 66, 0.31);
          }
        }
      }

      &.with-hover {
        .arrow:hover {
          background-color: #dcdfe4;

          &.swiper-button-disabled {
            background-color: transparent;
          }
        }
      }

      @media (max-width: 1870px) {
        left: calc(15dvw / 2);
      }

      @media (max-width: 1438px) {
        left: calc(calc(100dvw - 1128px) / 2);
      }

      @media (max-width: 1278px) {
        left: calc(4dvw / 2);
      }

      @media (max-width: 1247px) {
        top: -68px;
      }

      @media (max-width: 1023px) {
        left: 0;

        &.vlog {
          top: -68px;
        }
      }
    }

    @media (max-width: ${globalStyles.breackPoints.tablet}) {
      width: 100dvw;
    }
  }

  .swiper {
    width: 100%;

    @media (min-width: 1024px) {
      padding-left: calc(calc(4dvw - 32px) / 2);
      padding-right: calc(calc(4dvw - 32px) / 2);
    }

    @media (min-width: 1279px) {
      padding-left: calc(calc(100dvw - 1160px) / 2);
      padding-right: calc(calc(100dvw - 1160px) / 2);
    }

    @media (min-width: 1439px) {
      padding-left: calc(calc(15dvw - 32px) / 2);
      padding-right: calc(calc(15dvw - 32px) / 2);
    }

    @media (min-width: 1870px) {
      padding-left: calc(calc(100dvw - 1622px) / 2);
      padding-right: calc(calc(100dvw - 1622px) / 2);
    }
  }

  .swiper-slide:focus-visible {
    outline: none;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  }
`;
